import React from "react";
import { Navigate } from "react-router-dom";
import ManualUploads from "pages/manual-uploads";
import { Domain, useDomain } from "utils/stage-utils";

const ManualUploadsGuard: React.FC = () => {
  const domain = useDomain();
  if (domain === Domain.PROD) return <Navigate to="/" replace />;
  return <ManualUploads />;
};

export default ManualUploadsGuard;
